<!-- WRAPPER FOR TOAST -->
<!-- Why? This allows us to easily define alerts like when you're offline or whatever -->

<script setup lang="ts">
import { Toaster } from '@/components/ui/toast';
import { useToast } from '@/components/ui/toast/use-toast'
import { api } from '@/lib/util/api';
import { onMounted } from 'vue';
const { toast } = useToast();

const props = defineProps<{
    /** Make an alert for if the user or server is offline (basically if connection to server is not possible) */
    offlineAlert?: boolean
}>();

onMounted(async () => {
    if (props.offlineAlert) {
        const status = await api.status();
        // console.warn("Status", status);
        if (status == "offline") {
            toast({
                title: "⚠ Service Interruption",
                description: "I'm unable to reach the server at present.",
                type: "background",
                variant: "destructive"
            });
        }
    }
})

</script>

<template>
    <Toaster />
</template>

<style scoped></style>